export default class CalendarEntryEnum{
    static Session = new CalendarEntryEnum("CalendarEntrySession");
    static Announcement = new CalendarEntryEnum("CalendarEntryAnnouncement");
    constructor(name){
        this.name = name;
    }
}